import type { ReactNode } from 'react';
import { useI18n } from '../i18n/I18nProvider.js';
import { LanguagePicker } from '../i18n/LanguagePicker.js';

export interface AuthLayoutProps {
  readonly title: string;
  readonly subtitle?: string | undefined;
  readonly children: ReactNode;
  readonly footer?: ReactNode;
}

/** The shell every signed-out screen shares: calm, centred, one thing to do. */
export function AuthLayout({ title, subtitle, children, footer }: AuthLayoutProps): ReactNode {
  const { t } = useI18n();

  return (
    <div className="auth">
      <main className="auth__panel" id="main">
        <header className="auth__header">
          <img className="auth__logo" src="/mailbutlerlogo-v2.png" alt={t('app.name')} />
          <h1 className="auth__title">{title}</h1>
          {subtitle === undefined ? null : <p className="auth__subtitle">{subtitle}</p>}
        </header>

        {children}

        {footer === undefined ? null : <div className="auth__footer">{footer}</div>}
      </main>

      <div className="auth__aside">
        <LanguagePicker />
      </div>
    </div>
  );
}
